import React, { useState } from 'react';

interface VideoPlayerProps {
    src: string;
    className?: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ src, className = '' }) => {
    const [isYouTube, setIsYouTube] = useState(
        src.includes('youtube.com') || src.includes('youtu.be'),
    );

    // Extract YouTube video ID
    const getYouTubeEmbedUrl = (url: string) => {
        const regExp =
            /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        return match && match[2].length === 11
            ? `https://www.youtube.com/embed/${match[2]}?autoplay=1`
            : null;
    };

    // Render YouTube embed
    if (isYouTube) {
        const embedUrl = getYouTubeEmbedUrl(src);
        return embedUrl ? (
            <div className={`aspect-video w-full ${className}`}>
                <iframe
                    src={embedUrl}
                    title="YouTube Video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="h-full w-full rounded-lg"
                />
            </div>
        ) : (
            <div>Invalid YouTube URL</div>
        );
    }

    // Render local/direct video file
    return (
        <div className={`aspect-video w-full ${className}`}>
            <video controls autoPlay className="h-full w-full rounded-lg">
                <source src={src} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </div>
    );
};

export default VideoPlayer;
